import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";

import { DEFAULT_GAP } from "./constants";

export const ChipsWrapper = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style-type: none;
`;

export const EditIconContainer = styled(FlexRow)`
    align-items: center;
`;
export const ChipsTooltipWrapper = styled.div``;
export const MissingChipsItemTooltip = styled.div``;
export const ChipsContainer = styled(FlexRow)`
    align-items: center;
    gap: ${DEFAULT_GAP}px;
    flex-wrap: nowrap;
`;

export const ActionButtonWrapper = styled.div`
    cursor: pointer;

    svg > path {
        fill: ${colorsPalettes.carbon[250]};
    }
`;
